import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'
import { register } from '../services/players'

const PlaylistEvents = {
	Init: function () {
		const rteHeroVideo = $('.c-player.-eyecatcher')
		const playlistPlayer = $('.js-playlistplayer')
		// const playlistPlayerHeight = $(
		//     '.js-playlistplayer .c-time-duration-wrapper'
		// ).height();

		register((data = {}) => {
			const playerId = data?.customData?.videoID
			let player = null

			if (
				playlistPlayer.find(
					'button[data-playlist-video-id="' + playerId + '"]'
				).length > 0
			) {
				player = playlistPlayer
			} else {
				player = rteHeroVideo.parent()
			}

			// eslint-disable-next-line default-case
			switch (data.eventName) {
				case 'ui-entercinema':
					if (Utils.IsResponsive()) {
						$('body').addClass('player-in-cinema')
						// Keeping the old logic for the cinema player (fullscreen now)
						// This bunch of code must be done due to hardcoded iframe inline styles which are hard to override
						player
							.parents('.row')
							.addClass('c-player-cinema-expanded')

						player.find('.c-player').addClass('is-in-cinema-mode')

						$('meta[name=viewport]').attr(
							'content',
							'width=device-width, initial-scale=1.0, maximum-scale=1, viewport-fit=cover'
						)
					}
					break
				case 'ui-exitcinema':
				case 'ended':
					if (Utils.IsResponsive()) {
						$('body').removeClass('player-in-cinema')
						player
							.parents('.row')
							.removeClass('c-player-cinema-expanded')

						player
							.find('.c-player')
							.removeClass('is-in-cinema-mode')

						$('meta[name=viewport]').attr(
							'content',
							'width=device-width, initial-scale=1.0, maximum-scale=1'
						)
					}
					break
			}
		})
	},
}

// module.exports = PlaylistEvents;

export default PlaylistEvents
